import 'custom-event-polyfill';

export class EsAppHelper {
    public navigationWheel: NavigationWheel;
    constructor() {
        this.navigationWheel = new NavigationWheel();
    }
}

class NavigationWheel {
    private visible: boolean;
    constructor() {
        this.visible = true;
    }

    public isVisible() {
        return this.visible;
    }

    public show() {
        if (window) {
            const showNavWheelEvent = new CustomEvent('esapp.navigationwheel', {
                detail: {
                    visible: true,
                },
            });
            this.visible = true;
            document.dispatchEvent(showNavWheelEvent);
        }

    }
    public hide() {
        if (window) {
            const hideNavWheelEvent = new CustomEvent('esapp.navigationwheel', {
                detail: {
                    visible: false,
                },
            });
            this.visible = false;
            document.dispatchEvent(hideNavWheelEvent);
        }
    }

    public updateWheel(apiPrefix: string): void {
        const apiEndpoint = 'api/esapp/basket/itemcount';
        fetch(apiPrefix + apiEndpoint)
            .then(response => {
                if (!response.ok)
                    throw new Error(`Request failed with status ${response.status}`);

                return response.json();
            })
            .then((data: any) => {
                if (!data || data.basketItemCount === undefined || data.basketItemCount === null)
                    return;

                const responseBasketCount = data.basketItemCount.toString();

                sessionStorage.setItem('esAppBasketCount', responseBasketCount);

                document.dispatchEvent(new CustomEvent('basketChanged'));
                document.dispatchEvent(new CustomEvent('esApp.basketChanged'));
            });
    }
}
